export const getLoaderReadyEventName = (namespace: string) => `${namespace}-loader-ready`;
